import type { NotifySound } from './types'

// Notification sounds live in public/sounds and are served from the
// site root. Three registers: 7 = low/standard, 8 = medium, 9 = high.
const SOUND_SRC: Record<Exclude<NotifySound, 'off'>, string> = {
  '7': '/sounds/notify-7.wav',
  '8': '/sounds/notify-8.wav',
  '9': '/sounds/notify-9.wav',
}

// Reuse one Audio element per register so rapid-fire notifications don't
// spawn dozens of objects. We clone-and-play so overlapping pings still work.
const cache: Partial<Record<string, HTMLAudioElement>> = {}

/** Play a one-shot notification sound. No-op for 'off'. Best-effort:
 *  browsers block autoplay until the user has interacted with the page,
 *  in which case the play() promise rejects and we swallow it. */
export function playNotifySound(sound: NotifySound): void {
  if (sound === 'off') return
  const src = SOUND_SRC[sound]
  if (!src) return
  try {
    let base = cache[sound]
    if (!base) {
      base = new Audio(src)
      base.preload = 'auto'
      cache[sound] = base
    }
    // Clone so overlapping plays don't cut each other off.
    const node = base.cloneNode(true) as HTMLAudioElement
    node.volume = 0.5
    void node.play().catch(() => {
      /* autoplay blocked or asset missing — ignore */
    })
  } catch {
    /* ignore */
  }
}
